export default "__VITE_ASSET__P5Yh0D3a__"